import { render, staticRenderFns } from "./RecordLabel.vue?vue&type=template&id=049604c2&scoped=true"
import script from "./RecordLabel.vue?vue&type=script&lang=js"
export * from "./RecordLabel.vue?vue&type=script&lang=js"
import style0 from "./RecordLabel.vue?vue&type=style&index=0&id=049604c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049604c2",
  null
  
)

export default component.exports